import React, { Component } from 'react';
import { StyleSheet, View, Animated, Easing } from 'react-native';
import Collapsible from 'react-native-collapsible';
import R from '../../core-res/R';
import DRNText from '../../standard/Text/DRNText';
import DRNTouchableWrapper from '../../standard/Button/TouchableButtonWrapper';
import { withTheme } from '../../theme';
class DRNCollapsible extends Component {
    constructor(props) {
        super(props);
        this.handleHeaderPressed = () => {
            const { onOpen, onClose } = this.props;
            if (this.state.isCollapsed) {
                onOpen();
            }
            else {
                onClose();
            }
            this.setState({
                isCollapsed: !this.state.isCollapsed,
            });
        };
        this.state = {
            isCollapsed: props.isCollapsed,
        };
        this.chevronRotationValue = new Animated.Value(Number(props.isCollapsed));
        this.chevronRotation = this.chevronRotationValue.interpolate({
            inputRange: [0, 1],
            outputRange: ['0deg', '180deg'],
        });
    }
    componentDidUpdate(_, prevState) {
        if (this.state.isCollapsed !== prevState.isCollapsed) {
            Animated.timing(this.chevronRotationValue, {
                toValue: this.state.isCollapsed ? 1 : 0,
                duration: R.animation.timing.instant,
                easing: Easing.out(Easing.cubic),
            }).start();
        }
    }
    render() {
        const { isCollapsed } = this.state;
        const { headerText, headerStyle, IconStart, chevronTintColor, theme, disabled } = this.props;
        const headerTextColor = disabled ? theme.textMuted : theme.textPrimary;
        const defaultIconColor = disabled ? theme.textMuted : theme.tintPrimary;
        const headerBackgroundColor = disabled ? theme.lightNeutral : theme.lightPrimary;
        return (<View>
        <DRNTouchableWrapper onPress={this.handleHeaderPressed} disabled={disabled}>
          <View style={[
            styles.header,
            { borderBottomColor: theme.borderSubtle, backgroundColor: headerBackgroundColor },
            headerStyle,
        ]}>
            <View style={styles.headerTextContainer}>
              {IconStart && (<View style={styles.iconStart}>
                  <IconStart />
                </View>)}
              <DRNText style={[styles.headerText, { color: headerTextColor }]}>{headerText}</DRNText>
            </View>
            <Animated.Image style={[
            styles.headerIcon,
            { tintColor: chevronTintColor ? chevronTintColor : defaultIconColor },
            { transform: [{ rotateZ: this.chevronRotation }] },
        ]} source={require('../../../images/ic-sys-chevron-up.png')}/>
          </View>
        </DRNTouchableWrapper>
        <Collapsible collapsed={isCollapsed}>{this.props.children}</Collapsible>
      </View>);
    }
}
DRNCollapsible.defaultProps = {
    isCollapsed: true,
    headerStyle: {},
    disabled: false,
    onOpen: () => { },
    onClose: () => { },
};
const styles = StyleSheet.create({
    iconStart: {
        marginRight: R.spacing.s,
    },
    headerTextContainer: {
        flex: 1,
        flexDirection: 'row',
        alignItems: 'center',
    },
    header: {
        flexDirection: 'row',
        justifyContent: 'space-between',
        alignItems: 'center',
        padding: R.spacing.m,
        borderBottomWidth: R.border.width.thin,
    },
    headerText: Object.assign({ flex: 1 }, R.typography.title2),
    headerIcon: {
        height: 24,
        width: 24,
        marginLeft: R.spacing.xs,
    },
});
export default withTheme(DRNCollapsible);
